interface ICurrencyFormatterProps {
  amount: number;
}

const CurrencyFormatter = ({ amount }: ICurrencyFormatterProps) => {
  const formatAmount = (amountValue: number) => {
    return (
      amountValue?.toLocaleString('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }) || ''
    );
  };

  return <>{formatAmount(amount)}</>;
};

export default CurrencyFormatter;
